/* eslint-disable */ import { DomainEntityReflection, EnumReflection, RawAliasReflection, SchemaReflection } from '@salsita-ai/platform-project-sdk/domain';
export const modelVersion = 2;
export const PostType = new EnumReflection('PostType', {
    enum: [
        'Timber',
        'Metal'
    ]
});
export const BalustradeSectionType = new EnumReflection('BalustradeSectionType', {
    enum: [
        'End',
        'Intermediate'
    ]
});
export const FixingSystemType = new EnumReflection('FixingSystemType', {
    enum: [
        'ForkWithSaddles',
        'ForkWithScrewEyes',
        'TimberInsert',
        'FlipLock',
        'MetalInsert',
        'RigForkWithNutserts',
        'RigForkWithSaddles'
    ]
});
export const FinishType = new EnumReflection('FinishType', {
    enum: [
        'Bright',
        'BlackEtch'
    ]
});
export const PostShapeType = new EnumReflection('PostShapeType', {
    enum: [
        'Square',
        'Round',
        'Custom'
    ]
});
export const PostConnectionType = new EnumReflection('PostConnectionType', {
    enum: [
        'None',
        'Shared',
        'TwoPosts'
    ]
});
export const PositionType = new EnumReflection('PositionType', {
    enum: [
        'Intermediate',
        'ThinIntermediate',
        'AngledIntermediate',
        'LeftEnd',
        'RightEnd',
        'MidPost',
        'FlatFlatRight',
        'FlatFlatAcuteLeft',
        'FlatFlatAcuteRight',
        'FlatFlatObtuse',
        'StairsTopLeftEnd',
        'StairsTopRightEnd',
        'StairsBottomLeftEnd',
        'StairsBottomRightEnd',
        'FlatStairsStraightTopLeft',
        'FlatStairsStraightTopRight',
        'FlatStairsStraightBottomLeft',
        'FlatStairsStraightBottomRight',
        'FlatStairsCornerTopRight',
        'FlatStairsCornerTopLeft',
        'FlatStairsCornerBottomRight',
        'FlatStairsCornerBottomLeft',
        'FlatStairsOtherTopLeft',
        'FlatStairsOtherTopRight',
        'FlatStairsOtherBottomLeft',
        'FlatStairsOtherBottomRight',
        'StairsFlatOtherTopLeft',
        'StairsFlatOtherTopRight',
        'StairsFlatOtherBottomLeft',
        'StairsFlatOtherBottomRight'
    ]
});
export const FixingSystemPositionType = new EnumReflection('FixingSystemPositionType', {
    enum: [
        'Flat',
        'Obtuse',
        'Stairs'
    ]
});
export const FixingSystemAttachementType = new EnumReflection('FixingSystemAttachementType', {
    enum: [
        'Flat',
        'ObtuseRound',
        'ObtuseSquareRotated',
        'ObtuseSquareAdaptor',
        'StairsSimple',
        'StairsRotated',
        'StairsAdaptor'
    ]
});
export const PostStainlessFinishType = new EnumReflection('PostStainlessFinishType', {
    enum: [
        'Satin',
        'Mirror'
    ]
});
export const MetalPostStyleType = new EnumReflection('MetalPostStyleType', {
    enum: [
        'SquareAlu',
        'RoundStainless',
        'SquareStainless',
        'Custom'
    ]
});
export const ThinIntermediatePostType = new EnumReflection('ThinIntermediatePostType', {
    enum: [
        'SatinStainless',
        'MirrorStainless',
        'BlackAlu'
    ]
});
export const PostSharingType = new EnumReflection('PostSharingType', {
    enum: [
        'Last',
        'Both',
        'None'
    ]
});
export const HandrailType = new EnumReflection('HandrailType', {
    enum: [
        'FlatTimber',
        'RoundStainless',
        'SquareStainless'
    ]
});
export const HandrailEndType = new EnumReflection('HandrailEndType', {
    enum: [
        'RadiusedEndCap',
        'DomedEndCap',
        'FlatEndCap',
        'OblongWallPlate',
        'RoundWallPlate'
    ]
});
export const HandrailPossibleWallEndType = new EnumReflection('HandrailPossibleWallEndType', {
    enum: [
        'Free',
        'Wall'
    ]
});
export const BalustradePost = new SchemaReflection('BalustradePost', {
    type: 'object',
    properties: {
        key: {
            type: 'string'
        },
        x: {
            type: 'number'
        },
        y: {
            type: 'number'
        },
        positionType: PositionType._meta.schema,
        slope: {
            type: 'number'
        },
        shared: {
            type: 'boolean'
        }
    },
    required: [
        'key',
        'x',
        'y',
        'positionType',
        'slope',
        'shared'
    ],
    additionalProperties: false
});
export const BalustradeSection = new SchemaReflection('BalustradeSection', {
    type: 'object',
    properties: {
        key: {
            type: 'string'
        },
        posts: {
            type: 'array',
            items: BalustradePost._meta.schema
        },
        reverse: {
            type: 'boolean'
        },
        edgeOffset: {
            type: 'number'
        },
        height: {
            type: 'number'
        },
        section: BalustradeSectionType._meta.schema,
        length: {
            type: 'number'
        },
        slope: {
            type: 'number'
        },
        postSharingType: PostSharingType._meta.schema,
        left: {
            type: 'object',
            properties: {
                positionType: PositionType._meta.schema,
                connectionType: PostConnectionType._meta.schema,
                x: {
                    type: 'number'
                },
                angle: {
                    type: 'number'
                },
                slope: {
                    type: 'number'
                }
            },
            required: [
                'connectionType',
                'positionType',
                'x',
                'angle',
                'slope'
            ],
            additionalProperties: false
        },
        right: {
            type: 'object',
            properties: {
                positionType: PositionType._meta.schema,
                connectionType: PostConnectionType._meta.schema,
                x: {
                    type: 'number'
                },
                angle: {
                    type: 'number'
                },
                slope: {
                    type: 'number'
                }
            },
            required: [
                'connectionType',
                'positionType',
                'x',
                'angle',
                'slope'
            ],
            additionalProperties: false
        }
    },
    required: [
        'key',
        'posts',
        'reverse',
        'edgeOffset',
        'slope',
        'postSharingType',
        'left',
        'right',
        'section',
        'height',
        'length'
    ],
    additionalProperties: false
});
export const Balustrade = new SchemaReflection('Balustrade', {
    type: 'object',
    properties: {
        key: {
            type: 'string'
        },
        reverse: {
            type: 'boolean'
        },
        edgeOffset: {
            type: 'number'
        },
        postSharingType: PostSharingType._meta.schema,
        left: {
            type: 'object',
            properties: {
                positionType: PositionType._meta.schema,
                connectionType: PostConnectionType._meta.schema,
                x: {
                    type: 'number'
                },
                y: {
                    type: 'number'
                },
                angle: {
                    type: 'number'
                },
                slope: {
                    type: 'number'
                }
            },
            required: [
                'connectionType',
                'positionType',
                'x',
                'y',
                'angle',
                'slope'
            ],
            additionalProperties: false
        },
        right: {
            type: 'object',
            properties: {
                positionType: PositionType._meta.schema,
                connectionType: PostConnectionType._meta.schema,
                x: {
                    type: 'number'
                },
                y: {
                    type: 'number'
                },
                angle: {
                    type: 'number'
                },
                slope: {
                    type: 'number'
                }
            },
            required: [
                'connectionType',
                'positionType',
                'x',
                'y',
                'angle',
                'slope'
            ],
            additionalProperties: false
        },
        length: {
            type: 'number'
        },
        height: {
            type: 'number'
        },
        slope: {
            type: 'number'
        },
        sections: {
            type: 'array',
            items: BalustradeSection._meta.schema
        },
        handrail: {
            type: 'object',
            properties: {
                handrailStart: {
                    type: 'number'
                },
                handrailHeight: {
                    type: 'number'
                },
                handrailLength: {
                    type: 'number'
                },
                leftEndX: {
                    type: 'number'
                },
                leftEndHeight: {
                    type: 'number'
                },
                rightEndX: {
                    type: 'number'
                },
                rightEndHeight: {
                    type: 'number'
                },
                slope: {
                    type: 'number'
                },
                sharedRightEnd: {
                    type: 'boolean'
                },
                numberOfSections: {
                    type: 'number'
                },
                balustradeLength: {
                    type: 'number'
                }
            },
            required: [
                'handrailStart',
                'handrailHeight',
                'leftEndX',
                'leftEndHeight',
                'rightEndX',
                'rightEndHeight',
                'handrailLength',
                'slope',
                'sharedRightEnd',
                'numberOfSections',
                'balustradeLength'
            ],
            additionalProperties: false
        }
    },
    required: [
        'key',
        'reverse',
        'edgeOffset',
        'postSharingType',
        'left',
        'right',
        'length',
        'height',
        'slope',
        'sections',
        'handrail'
    ],
    additionalProperties: false
});
export const FixingSystemAttachementData = new SchemaReflection('FixingSystemAttachementData', {
    type: 'object',
    properties: {
        partCenterOffset: {
            type: 'number'
        },
        fixingSystemObjectName: {
            type: 'string'
        },
        wireObjectName: {
            type: 'string'
        },
        scaleZero: {
            type: 'number'
        },
        scaleOne: {
            type: 'number'
        },
        material: {
            type: 'string'
        },
        fixingSystemSkus: {
            type: 'array',
            items: {
                type: 'string'
            }
        },
        wireSku: {
            type: 'string'
        },
        fixingSystemAttachementType: FixingSystemAttachementType._meta.schema
    },
    required: [
        'partCenterOffset',
        'fixingSystemObjectName',
        'wireObjectName',
        'scaleZero',
        'scaleOne',
        'material',
        'fixingSystemSkus',
        'wireSku',
        'fixingSystemAttachementType'
    ],
    additionalProperties: false
});
export const PartObject = new SchemaReflection('PartObject', {
    type: 'object',
    properties: {
        key: {
            type: 'string'
        },
        x: {
            type: 'number'
        },
        y: {
            type: 'number'
        },
        z: {
            type: 'number'
        },
        rotationX: {
            type: 'number'
        },
        rotationY: {
            type: 'number'
        },
        rotationZ: {
            type: 'number'
        },
        scaleX: {
            type: 'number'
        },
        scaleY: {
            type: 'number'
        },
        scaleZ: {
            type: 'number'
        },
        fileUrl: {
            type: 'string'
        },
        objectName: {
            type: 'string'
        },
        material: {
            type: 'string'
        },
        metalness: {
            type: 'number'
        },
        color: {
            type: 'string'
        },
        morphTargetInfluences: {
            type: 'object',
            properties: {
                length: {
                    type: 'object',
                    properties: {
                        value: {
                            type: 'number'
                        },
                        scaleZero: {
                            type: 'number'
                        },
                        scaleOne: {
                            type: 'number'
                        }
                    },
                    required: [
                        'value',
                        'scaleZero',
                        'scaleOne'
                    ],
                    additionalProperties: false
                },
                angle: {
                    type: 'object',
                    properties: {
                        value: {
                            type: 'number'
                        },
                        scaleZero: {
                            type: 'number'
                        },
                        scaleOne: {
                            type: 'number'
                        }
                    },
                    required: [
                        'value',
                        'scaleZero',
                        'scaleOne'
                    ],
                    additionalProperties: false
                },
                width: {
                    type: 'object',
                    properties: {
                        value: {
                            type: 'number'
                        },
                        scaleZero: {
                            type: 'number'
                        },
                        scaleOne: {
                            type: 'number'
                        }
                    },
                    required: [
                        'value',
                        'scaleZero',
                        'scaleOne'
                    ],
                    additionalProperties: false
                },
                height: {
                    type: 'object',
                    properties: {
                        value: {
                            type: 'number'
                        },
                        scaleZero: {
                            type: 'number'
                        },
                        scaleOne: {
                            type: 'number'
                        }
                    },
                    required: [
                        'value',
                        'scaleZero',
                        'scaleOne'
                    ],
                    additionalProperties: false
                }
            },
            additionalProperties: false
        }
    },
    required: [
        'key',
        'fileUrl',
        'objectName',
        'material'
    ],
    additionalProperties: false
});
export const SKU = new SchemaReflection('SKU', {
    type: 'object',
    properties: {
        sku: {
            type: 'string'
        },
        metadata: {
            type: 'object',
            additionalProperties: true
        }
    },
    required: [
        'sku',
        'metadata'
    ],
    additionalProperties: false
});
export const Product = new SchemaReflection('Product', {
    type: 'object',
    properties: {
        title: {
            type: 'string'
        },
        subtitle: {
            type: 'string'
        },
        thumbnailUrl: {
            type: 'string'
        },
        remoteThubnail: {
            type: 'boolean'
        },
        price: {
            type: 'number'
        },
        sold: {
            type: 'boolean'
        },
        link: {
            type: 'string'
        }
    },
    required: [
        'title',
        'subtitle',
        'price',
        'sold'
    ],
    additionalProperties: false
});
export const ProductInstance = new SchemaReflection('ProductInstance', {
    type: 'object',
    properties: {
        title: {
            type: 'string'
        },
        subtitle: {
            type: 'string'
        },
        thumbnailUrl: {
            type: 'string'
        },
        remoteThubnail: {
            type: 'boolean'
        },
        price: {
            type: 'number'
        },
        sold: {
            type: 'boolean'
        },
        key: {
            type: 'string'
        }
    },
    required: [
        'title',
        'subtitle',
        'price',
        'sold',
        'key'
    ],
    additionalProperties: false
});
export const ProductSummary = new SchemaReflection('ProductSummary', {
    type: 'object',
    properties: {
        key: {
            type: 'string'
        },
        title: {
            type: 'string'
        },
        subtitle: {
            type: 'string'
        },
        thumbnailUrl: {
            type: 'string'
        },
        remoteThubnail: {
            type: 'boolean'
        },
        amount: {
            type: 'number'
        },
        price: {
            type: 'number'
        },
        total: {
            type: 'number'
        },
        link: {
            type: 'string'
        }
    },
    required: [
        'title',
        'subtitle',
        'amount',
        'key',
        'total',
        'price'
    ],
    additionalProperties: false
});
const DeckShape = new SchemaReflection('DeckShape', {
    type: 'object',
    properties: {
        postType: PostType._meta.schema,
        numberOfWires: {
            type: 'number'
        },
        finish: FinishType._meta.schema,
        useThinIntermediatePosts: {
            type: 'boolean'
        },
        thinIntermediatePostType: ThinIntermediatePostType._meta.schema,
        postStyle: MetalPostStyleType._meta.schema,
        postStainlessFinish: PostStainlessFinishType._meta.schema,
        fixingSystem: FixingSystemType._meta.schema,
        handrailType: HandrailType._meta.schema
    },
    additionalProperties: false,
    required: [
        'postType',
        'numberOfWires',
        'finish',
        'useThinIntermediatePosts',
        'thinIntermediatePostType',
        'postStyle',
        'postStainlessFinish',
        'fixingSystem',
        'handrailType'
    ]
});
const DeckSectionShape = new SchemaReflection('DeckSectionShape', {
    type: 'object',
    properties: {
        x: {
            type: 'number'
        },
        y: {
            type: 'number'
        },
        length: {
            type: 'number'
        },
        angle: {
            type: 'number'
        },
        balustrade: {
            type: 'boolean'
        }
    },
    additionalProperties: false,
    required: [
        'x',
        'y',
        'length',
        'angle',
        'balustrade'
    ]
});
const StairsShape = new SchemaReflection('StairsShape', {
    type: 'object',
    properties: {
        x: {
            type: 'number'
        },
        y: {
            type: 'number'
        },
        width: {
            type: 'number'
        },
        angle: {
            type: 'number'
        },
        balustradeLeft: {
            type: 'boolean'
        },
        balustradeRight: {
            type: 'boolean'
        },
        numberOfSteps: {
            type: 'number'
        },
        riserDistance: {
            type: 'number'
        },
        goingDistance: {
            type: 'number'
        }
    },
    additionalProperties: false,
    required: [
        'x',
        'y',
        'width',
        'angle',
        'balustradeLeft',
        'balustradeRight',
        'numberOfSteps',
        'riserDistance',
        'goingDistance'
    ]
});
const ProjectedEntityShape = new SchemaReflection('ProjectedEntityShape', {
    type: 'object',
    properties: {
        key: {
            type: 'string'
        },
        deckItemId: {
            type: 'string',
            pattern: '^[A-Z]\\w*-\\d+$'
        }
    },
    additionalProperties: false,
    required: [
        'key',
        'deckItemId'
    ]
});
const PostShape = new SchemaReflection('PostShape', {
    type: 'object',
    properties: {
        x: {
            type: 'number'
        },
        y: {
            type: 'number'
        },
        z: {
            type: 'number'
        },
        positionType: PositionType._meta.schema,
        slope: {
            type: 'number'
        }
    },
    additionalProperties: false,
    required: [
        'x',
        'y',
        'z',
        'positionType',
        'slope'
    ]
});
const FixingSystemShape = new SchemaReflection('FixingSystemShape', {
    type: 'object',
    properties: {
        leftPositionType: PositionType._meta.schema,
        leftX: {
            type: 'number'
        },
        leftY: {
            type: 'number'
        },
        leftZ: {
            type: 'number'
        },
        rightPositionType: PositionType._meta.schema,
        rightX: {
            type: 'number'
        },
        rightY: {
            type: 'number'
        },
        rightZ: {
            type: 'number'
        },
        rightAngle: {
            type: 'number'
        },
        sectionSlope: {
            type: 'number'
        },
        order: {
            type: 'number'
        }
    },
    additionalProperties: false,
    required: [
        'leftPositionType',
        'leftX',
        'leftY',
        'leftZ',
        'rightPositionType',
        'rightX',
        'rightY',
        'rightZ',
        'rightAngle',
        'sectionSlope',
        'order'
    ]
});
const HandrailShape = new SchemaReflection('HandrailShape', {
    type: 'object',
    properties: {
        x: {
            type: 'number'
        },
        y: {
            type: 'number'
        },
        z: {
            type: 'number'
        },
        rotationY: {
            type: 'number'
        },
        rotationX: {
            type: 'number'
        },
        rotationZ: {
            type: 'number'
        },
        length: {
            type: 'number'
        },
        leftPositionType: {
            oneOf: [
                PositionType._meta.schema,
                {
                    type: 'null'
                }
            ]
        },
        rightPositionType: {
            oneOf: [
                PositionType._meta.schema,
                {
                    type: 'null'
                }
            ]
        },
        numberOfSections: {
            type: 'number'
        },
        balustradeLength: {
            type: 'number'
        }
    },
    additionalProperties: false,
    required: [
        'x',
        'y',
        'z',
        'rotationY',
        'rotationX',
        'rotationZ',
        'length',
        'leftPositionType',
        'rightPositionType',
        'numberOfSections',
        'balustradeLength'
    ]
});
const HandrailEndShape = new SchemaReflection('HandrailEndShape', {
    type: 'object',
    properties: {
        x: {
            type: 'number'
        },
        y: {
            type: 'number'
        },
        z: {
            type: 'number'
        },
        positionType: PositionType._meta.schema,
        possibleWallEndType: HandrailPossibleWallEndType._meta.schema,
        endType: HandrailEndType._meta.schema,
        angle: {
            type: 'number'
        },
        slope: {
            type: 'number'
        }
    },
    additionalProperties: false,
    required: [
        'x',
        'y',
        'z',
        'positionType',
        'possibleWallEndType',
        'endType',
        'angle',
        'slope'
    ]
});
export const Deck = new DomainEntityReflection('Deck', [
    DeckShape._meta.schema
]);
export const DeckSection = new DomainEntityReflection('DeckSection', [
    DeckSectionShape._meta.schema
]);
export const Stairs = new DomainEntityReflection('Stairs', [
    StairsShape._meta.schema
]);
export const Post = new DomainEntityReflection('Post', [
    PostShape._meta.schema,
    ProjectedEntityShape._meta.schema
]);
export const FixingSystem = new DomainEntityReflection('FixingSystem', [
    FixingSystemShape._meta.schema,
    ProjectedEntityShape._meta.schema
]);
export const Handrail = new DomainEntityReflection('Handrail', [
    HandrailShape._meta.schema,
    ProjectedEntityShape._meta.schema
]);
export const HandrailEnd = new DomainEntityReflection('HandrailEnd', [
    HandrailEndShape._meta.schema,
    ProjectedEntityShape._meta.schema
]);
export const AnyDomainEntity = new RawAliasReflection('AnyDomainEntity', [
    Deck,
    DeckSection,
    Stairs,
    Post,
    FixingSystem,
    Handrail,
    HandrailEnd
]);
export const RootEntity = new RawAliasReflection('RootEntity', [
    Deck
]);
export const DeckItem = new RawAliasReflection('DeckItem', [
    DeckSection,
    Stairs
]);
export const ProjectedEntity = new RawAliasReflection('ProjectedEntity', [
    Post,
    FixingSystem,
    Handrail,
    HandrailEnd
]);
export const aliases = {
    AnyDomainEntity: AnyDomainEntity.types,
    RootEntity: RootEntity.types,
    DeckItem: DeckItem.types,
    ProjectedEntity: ProjectedEntity.types
};
export const entities = {
    Deck,
    DeckSection,
    Stairs,
    Post,
    FixingSystem,
    Handrail,
    HandrailEnd
};

//# sourceMappingURL=v2.js.map